import { SortMeta } from 'primeng/api';
import { ColumnSort } from '../../osp-ui/components/data/table/contract/column-sort.contract';
import { convertSortMetaToColumnSort } from './convert-sort-meta-to-column-sort';
import { isSortMeta } from './is-sort-meta';

export function toSortString(sort: ColumnSort | SortMeta | null | undefined, postfix?: string): string {
  const columnSort = isSortMeta(sort) ? convertSortMetaToColumnSort(sort) : sort;
  return columnSort?.field && columnSort?.direction
    ? `${columnSort.field}${postfix ? `.${postfix}` : ''},${columnSort.direction}`
    : '';
}
